import { render } from "./OrderAttachments.vue?vue&type=template&id=014a7356&scoped=true"
import script from "./OrderAttachments.vue?vue&type=script&lang=js"
export * from "./OrderAttachments.vue?vue&type=script&lang=js"

import "./OrderAttachments.vue?vue&type=style&index=0&id=014a7356&scoped=true&lang=css"

import exportComponent from "/var/www/abg/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-014a7356"]])

export default __exports__